/**
 * Bind all methods in a class so that nested method calls work as you'd expect
 * @link [explanation](https://stackoverflow.com/questions/56503531/what-is-a-good-way-to-automatically-bind-js-class-methods)
 */
export function classBindThis(_this: any): void {
  Object.getOwnPropertyNames(Object.getPrototypeOf(_this))
    .filter((m) => m !== "constructor")
    .forEach((method) => {
      _this[method] = _this[method].bind(_this)
    })
}
